import '../../assets/style/Topbar.css';

import our1 from "../../assets/icon/our1.svg";
import our2 from "../../assets/icon/our2.svg";
import our3 from "../../assets/icon/our3.svg";
import our4 from "../../assets/icon/our4.svg";
import our5 from "../../assets/icon/our5.svg"

import bb from "../../assets/icon/burgerBar.svg";

import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";

function Topbar(params) {
    const { t, i18n } = useTranslation();

    const [dropdown, setDropdown] = useState(false);
    const [menu, setMenu] = useState(false);
    const [down, setDown] = useState("topbar");
    
    const [disapear, setDisapear] = useState({});
    const [language, setLanguage] = useState(localStorage.getItem("language") || "US");

    const changeLanguage = (lang) => {
        setLanguage(lang)
        i18n.changeLanguage(lang);
        localStorage.setItem("language", lang); 
        setDisapear({transition: "0s", opacity: "0"})
        setTimeout(() => {
            setDisapear({transition: "0.5s", opacity: "1"})
        }, 200)
    };  
    const active = params.state;

    window.onclick = function(event){
        if(event.target.className === "downTopbar" && menu === false ){
            setDropdown(!dropdown);
        } else {
            setDropdown(false);
        }

        if(event.target.className === "mobileIconTopbar" || event.target.className === "iconTopbar"){
            setMenu(!menu);
        } else {
            
            if(event.target.className === "downTopbar"){
                setDropdown(!dropdown);
            } else {
                setMenu(false);
            }
            
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset;
            if (scrollTop <= 0) {
              setDown("topbar");
            } else {
              setDown("topbar shadowTopbar");
            }
        };
      
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    const listOur = [{
        icon: our1,
        title: t("topbarproductTitle1"),
        text: t("topbarproductText1"),
        link: '/demo'
    },
    {
        icon: our2,
        title: t("topbarproductTitle2"),
        text: t("topbarproductText2"),
        link: '/software'
    },
    {
        icon: our3,
        title: t("topbarproductTitle3"),
        text: t("topbarproductText3"),
        link: '/bigdata'
    },
    {
        icon: our4,
        title: t("topbarproductTitle4"),
        text: t("topbarproductText4"),
        link: '/data'
    },
    {
        icon: our5,
        title: t("topbarproductTitle5"),
        text: t("topbarproductText5"),
        link: '/aiservices'
    
    }];

    const balikAtas = () => {
        document.body.scrollIntoView({
            behavior: "smooth",
        });
    };

    return(
        <header className={down} id='Topbar'>
            <section>
                <Link to={"/"}>
                    <img src="/photo/Logo.webp" className='logoTopbar' alt="Logo" onClick={() => balikAtas() }></img>
                </Link>
            </section>
            <section className='menuTopbar goneMobile'>
                <ul className='menuNavBarTopbar'>
                    <li>
                        <Link to={"/"} className={active === "Homepage" ? "activeTopbar" : ""} onClick={() => balikAtas() }>{t("topbarmenu1")}</Link>
                    </li>
                    <li>
                        <Link className='downTopbar'>
                            {t("topbarmenu2")}
                        </Link>
                        <div className={dropdown ? 'dropdownTopbar' : 'dropdownTopbar noneTopbar'}>
                            {listOur.map((item, index) => (
                                <Link key={index} to={item.link} className='itemOurTopbar' onClick={() => balikAtas()}>
                                    <img src={item.icon} alt='icon'/> 
                                    <div className='ketOurTopbar'>
                                        <p className='titleOurTopbar'>{item.title}</p>
                                        <p className='textOurTopbar'>{item.text}</p>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </li>
                    <li>
                        <Link to={"/about-us"} className={active === "About Us" ? "activeTopbar" : ""} onClick={() => balikAtas() }>{t("topbarmenu3")}</Link>
                    </li>
                    <li>
                        <a  className="ContactUs" onClick={() => {
                            window.scrollTo({
                            top: document.body.scrollHeight,
                            behavior: "smooth"
                            });
                        }} >{t("topbarmenu4")}</a>
                    </li>
                </ul>
                <Link to={"/contact-us"} onClick={() => balikAtas() }>
                    <button className='buttonTopbar'>
                    {t("topbarfreeConsultation")}
                    </button>
                </Link>

                <img src={language == "ID" ? "/photo/id.webp" : "/photo/us.webp"} 
                className='langch'
                style={disapear}
                onClick={() => {
                    language == "ID" ? changeLanguage("US") :  changeLanguage("ID")
                }}
                alt='flag'
                />


            </section>

            {/* Mobile */}
            <section className='mobileIconTopbar' >
                <img src={bb} className='iconTopbar' alt="what?"/>
                <div className={menu ? 'listMenuTopbar' : 'listMenuTopbar'} style={{opacity: !menu ? "0" : "1", transition: "all .2s", visibility: !menu ? "hidden" : "visible"}}>
                    <Link to={"/"} className={active === "Homepage" ? "activeTopbar" : ""} onClick={() => balikAtas() }>Home</Link>
                    <Link className='downTopbar'>
                        Our Service
                    </Link>
                    <div className={dropdown ? 'ls' : 'ls noneTopbar'} >
                    {listOur.map((item, index) => (
                        <Link key={index} to={item.link} className='itemOurTopbar' onClick={() => balikAtas() }>
                            <div className='ketOurTopbar'>
                                <p className='titleOurTopbar'>{item.title}</p>
                            </div>
                        </Link>
                    ))}
                    </div>
                    <Link to={"/about-us"} className={active === "About Us" ? "activeTopbar" : ""} onClick={() => balikAtas() }>About Us</Link>
                    <a href={'#Footer'} className="ContactUs" >Contact Information</a>
                    <Link to={"/contact-us"} onClick={() => balikAtas() }>
                        <button className='buttonTopbar'>
                            Free Consultation
                        </button>
                    </Link>
                    <img src={language == "ID" ? "/photo/id.webp" : "/photo/us.webp"} 
                    className='langch'
                    style={disapear}
                    onClick={() => {
                        language == "ID" ? changeLanguage("US") :  changeLanguage("ID")
                    }}
                    alt='flag'
                    />
                </div>
            </section>
        </header>
    );
};

export default Topbar;